<template>
  <div class="system-overview">
    <leaflet-map ref="leafMap" :devicesOption="devicesOption"></leaflet-map>
    <div class="left">
      <div class="devices-info">
        <div class="title">{{$t('lang.Monitor.deviceOverview')}}</div>
        <div class="no-permission" v-if="this.Permission.indexOf(221) === -1">无权限</div>
        <div class="deviceInfoChart" v-else>
          <deviceInfoChart :options="deviceInfoChart" :autoresize="true"></deviceInfoChart>
          <div class="num">
            <div class="num-item">{{$t('lang.Monitor.deviceTotalNumber')}}：{{deviceInfo.allNum}}</div>
            <div class="num-item">{{$t('lang.Monitor.totalOnline')}}：{{deviceInfo.onlineNum}}</div>
            <div class="num-item">{{$t('lang.Monitor.totalOffline')}}：{{deviceInfo.offlineNum}}</div>
          </div>
        </div>
      </div>
      <div class="divices-list">
        <div class="title">{{$t('lang.Monitor.deviceList')}}</div>
         <div class="no-permission" v-if="this.Permission.indexOf(222) === -1">无权限</div>
        <div class="devices-search" v-if="this.Permission.indexOf(222) !== -1">
          <el-input v-model="deviceSearch" size="mini" clearable :placeholder="$t('lang.Monitor.deviceSearch')"></el-input>
        </div>
        <div class="device-scroll" v-if="this.Permission.indexOf(222) !== -1">
          <div class="devicesTrees">
            <el-tree
              highlight-current
              ref="deviceTrees"
              :data="devicesOption" 
              @node-click="clickDevice"
              :filter-node-method="filterDevices"
              :props="devicesTreeProps">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-tag v-if="data.deviceIsconnected == 3" style="width: 100px;text-align: center;" size="small" type="success">{{$t('lang.Monitor.connected')}}</el-tag>
                <el-tag v-else size="small" type="danger" style="width: 100px;text-align: center;">{{$t('lang.Monitor.disconnected')}}</el-tag>
                {{node.label}}({{data.deviceName ? data.deviceName : 'N/A'}})
              </span>
            </el-tree>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="alarm-statistics">
        <div class="title">{{$t('lang.Monitor.alarmStatistics')}}</div>
        <div class="no-permission" v-if="this.Permission.indexOf(223) === -1">无权限</div>
        <div class="alarmStatisticsChart" v-else>
          <alarmStatisticsChart :options="alarmStatisticsChart" :autoresize="true"></alarmStatisticsChart>
          <div class="num">
            <div class="num-item">{{$t('lang.Monitor.todayTotalNumber')}}：{{alarmStatistic.alarmAllNum}}</div>
            <div class="num-item">{{$t('lang.Monitor.todayProcessedNumber')}}：{{alarmStatistic.alarmOffNum}}</div>
            <div class="num-item">{{$t('lang.Monitor.todayUnprocessedNumber')}}：{{alarmStatistic.alarmOnNum}}</div>
          </div>
        </div>
      </div> 
      <div class="alram-info">
        <div class="title">{{$t('lang.Monitor.alarmInfo')}}</div>
        <div class="alram-list">
          <div class="alarm-scroll">
            <div
            v-for="(item, index) in alarmList"
            :key="item.id">
            <el-divider></el-divider>
            <div 
              :class="alarmItemSrtyle[index] ? alarmItemSrtyle[index] : 'alarm-item'"
              @click="clickAlarm(item, index)">
              <el-popover
                placement="left"
                width="100%"
                trigger="click">
                <div class="alarm-status">
                  <p class="alarm-status_title">{{$t('lang.rightAlarm.Alarmhandling')}}</p>
                  <el-form label-position="right" label-width="120px">
                    <el-form-item :label="$t('lang.rightAlarm.Alarmstart')">
                      <span>{{item.sts | formateTime}}</span>
                    </el-form-item>
                    <el-form-item :label="$t('lang.rightAlarm.Alarmend')">
                      <span>{{item.ets | formateTime}}</span>
                    </el-form-item>
                    <el-form-item :label="$t('lang.rightAlarm.Alarmresult')">
                      <span v-if="item.state == 1">
                        {{item.description}}
                      </span>
                      <el-tag size="small" type="danger" v-else>{{$t('lang.rightAlarm.notprocessed')}}</el-tag>
                    </el-form-item>
                    <el-form-item v-if="item.state == 0" :label="$t('lang.rightAlarm.Processing')">
                      <el-input type="textarea" :rows="2" v-model="description" :placeholder="$t('lang.rightAlarm.Processing')"></el-input>
                    </el-form-item>
                  </el-form>
                  <div v-if="item.state == 0" class="alarm-status_button">
                    <el-button size="mini" type="primary" @click="save(item)">{{$t('lang.rightAlarm.save')}}</el-button>
                  </div>
                </div>
                <div slot="reference">
                  <div>
                    <span>{{$t('lang.rightAlarm.equipment')}}</span>
                    <span>{{item.dname}}</span>
                  </div>
                  <div>
                    <span>{{$t('lang.rightAlarm.terminal')}}</span>
                    <span>{{item.dtuname}}</span>
                  </div>
                  <div>
                    <span>{{$t('lang.rightAlarm.variable')}}</span>
                    <span>{{item.vname}}</span>
                  </div>
                  <div>
                    <span>{{$t('lang.rightAlarm.content')}}</span>
                    <span>{{item.alarmContent}}</span>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDeviceList, getListByGroup, queryDevices } from '@/api/cloudMonitor/deviceList'
import { getDeviceStatistics, getAlarmStatistics, getAlarmInfo } from '@/api/cloudMonitor/systemOverview'
import { handleAlarm } from '@/api/cloudMonitor/alarmList'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/polar'
import leafletMap from '../map/leafletMap'
import moment from 'moment'
import { getPermission } from '@/cookie/cookie'
import { cloneDeep } from 'lodash'
export default {
  data() {
    return {
      Permission: [],
      // 设备列表搜索框变量
      deviceSearch: '',
      deviceTotal: 0,
      // 设备概况信息
      deviceInfo: {
        allNum: 0,
        onlineNum: 0,
        offlineNum: 0,
      },
      // 今日报警统计
      alarmStatistic: {
        alarmAllNum: 0,
        alarmOnNum: 0,
        alarmOffNum: 0
      },
      alarmItemSrtyle: [],
      // 报警信息列表
      alarmList: [],
      deviceInfoChart: {},
      alarmStatisticsChart: {},
      // 饼图样式，两个饼图样式一样
      pieLabel: {
        show: false,
        position: 'center',
        emphasis: {
          show: true,
          textStyle: {
            fontSize: '18',
            fontWeight: 'bold'
          }
        }
      },
      devicesOption: [],
      devicesTreeProps: {
        label: 'deviceSn',
        chidlren: 'children'
      },
      description: '',
      timer: null
    }
  },
  components: {
    leafletMap,
    'deviceInfoChart': ECharts,
    'alarmStatisticsChart': ECharts,
  },
  filters: {
    formateTime(time) {
      if(time) {
        return moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss')
      }else{
        return ''
      }
    }
  },
  watch: {
    deviceSearch() {
      this.$nextTick(() => {
        this.$refs.deviceTrees.filter(this.deviceSearch)
      })

    }
  },
  mounted() {
  },
  activated() {
    clearInterval(this.timer)
    this.Permission = getPermission()
    if(this.Permission.indexOf(207) !== -1 && this.Permission.indexOf(211) !== -1) {
      this.getList()
      this.getDeviceInfo()
      this.getTodayAlarm()
      this.getAlarmList()
      this.timer = setInterval(() => {
        this.getList()
        this.getDeviceInfo()
        this.getTodayAlarm()
        this.getAlarmList()
      }, 10000)
    }
  },
  deactivated() {
    clearInterval(this.timer)
  },
  methods: {
    // 获取设备列表
    getList() {
      let params = {
        current: 1,
        size: 99999,
        deviceSn: this.deviceSearch ? this.deviceSearch : undefined
      }
      queryDevices(params).then(res => {
        if(res.data.code === 0) {
          let data = res.data.data
          this.devicesOption = data.records
          this.deviceTotal = data.total
        }
      })
    },
    // 获取设备概况信息
    getDeviceInfo() {
      getDeviceStatistics().then(res => {
        if(res.data.code === 0) {
          this.deviceInfo = res.data.data
        }
        this.initDeviceInfo()
      })
    },

    // 获取今日报警统计
    getTodayAlarm() {
      getAlarmStatistics().then(res => {
        if(res.data.code === 0) {
          this.alarmStatistic = res.data.data
        }
        this.initalarmStatistics()
      })
    },
    // 获取今日报警信息
    getAlarmList() {
      getAlarmInfo().then(res => {
        this.alarmList = res.data.data
      })
    },
    initDeviceInfo() {
      this.deviceInfoChart = {
        tooltip: {
          trigger: 'item',
          formatter: `{b} : {c} <br/>${this.$t('lang.dashboard.form')} ：{d}%`,
          confine:true
        },
        series: [
          {
            name: this.$t('lang.Monitor.deviceOverview'),
            label: this.pieLabel,
            type: 'pie',
            radius: ['60%', '75%'],
            center: ['45%', '50%'],
            data:[
              { value: this.deviceInfo.offlineNum, name: this.$t('lang.HangingDevice.offline')},
              { value: this.deviceInfo.onlineNum, name: this.$t('lang.HangingDevice.online')},
            ],
            color:['#ef4b4c','#b1eadb']
          }
        ]
      }
    },
    initalarmStatistics() {
      this.alarmStatisticsChart = {
        tooltip: {
          trigger: 'item',
          formatter: `{b} : {c} <br/>${this.$t('lang.dashboard.form')} ：{d}%`,
          confine:true
        },
         series: [
          {
            name: this.$t('lang.Monitor.alarmStatistics'),
            label: this.pieLabel,
            type: 'pie',
            radius: ['60%', '75%'],
            center: ['45%', '50%'],
            data:[
              { value: this.alarmStatistic.alarmOffNum, name: this.$t('lang.Monitor.Unprocessed')},
              { value: this.alarmStatistic.alarmOnNum, name: this.$t('lang.Monitor.Processed')},
            ],
            color:['#ef4b4c','#b1eadb']
          }
        ]
      }
    },
    // 点击设备
    clickDevice(data) {
      this.$refs.leafMap.setDeviceView(data)
    },
    // 筛选设备
    filterDevices(value, data, node) {
      if (!value) {
        return true
      }else{
        // 名称不区分大小写搜索
        return data.deviceSn && data.deviceSn.includes(value.trim()) || data.deviceName && (data.deviceName.toLowerCase()).includes((value.toLowerCase()).trim())
      }
    },
    // 点击了某条报警信息
    clickAlarm(item, index) {
      // 先把之前的置为初始化
      let itemSrtyle = this.alarmItemSrtyle[index]
      this.alarmItemSrtyle.splice(0, this.alarmItemSrtyle.length)
      this.$set(this.alarmItemSrtyle, index, 'alarm-item_highlight')
    },
    // 保存处理
    save(item) {
      let params = {
        id: item.id,
        description: this.description
      }
      handleAlarm(params).then(res => {
        if(res.data.code === 0) {
          this.getAlarmList()
          this.$message.success('保存成功！')
          this.description = ''
        }else{
          this.$message.error('保存失败！')
        }
      }).catch(() => {
        this.$message.error('请求失败， 请重试！')
      })
    },
  }
}
</script>
<style scoped>
.system-overview{
  display: flex;
  width: 100%;
  height: 75vh;
  border: 2px solid rgb(0, 116, 199);
  border-radius: 20px;
  margin-top: 20px;
  overflow: hidden;
  position: relative;
  color: white;
  font-size: 16px;
}
.left{
  width: 20%;
  height: 100%;
  position: absolute;
  z-index: 999;
}
.right{
  width: 20%;
  height: 100%;
  position: absolute;
  right: 0;
  z-index: 999;
}
.divices-list, .alram-info{
  margin-top: 10px;
  height: 60%;
}
.divices-list {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.devicesTrees{
  padding-left: 10px;
  width: 100%;
  height: 100%;
  /* overflow: scroll; */
}
.divices-list, .devices-info, .alarm-statistics, .alram-info{
  background-color:rgba(24, 90, 116, 0.6);
  border-radius: 20px;
  width: 100%;
}
.devices-info, .alarm-statistics{
  height: 40%;
  display: flex;
  flex-direction: column;
}
.title{
  font-size: 18px;
  font-weight: bolder;
  padding-top: 10px;
  margin-bottom: 20px;
  color: white;
  padding-left: 10px;
  padding-top: 10px;
}
.deviceInfoChart, .alarmStatisticsChart{
  width: 100%;
  height: 100%;
  display: flex;

  flex-direction: column;
}
.alram-list{
  width: 100%;
  /* height: 100%; */
  height: 70%;
  overflow: auto;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
}
.echarts {
  width: 100%;
  height: 60%;
}
.num{
  font-size: 16px;
  font-weight: bolder;
  display: flex;
  color: white;
  padding-top: 20px;
  padding-left: 10px;
  flex-wrap: wrap;
}
.num-item {
  margin-right: 15px;
  margin-bottom: 10px;
}
.devices-search{
  padding: 10px 10px 0px 10px;
}
.el-select{
  width: 100%;
}
.top-chart{
  width: 100%;
  height: 40%;
  display: flex;
  justify-content: space-between;
}
.el-tree{
  background-color: transparent;
  margin-top: 20px;
  color: white;
  font-size: 16px;
  font-weight: bolder;
}
.divices-list >>> .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: rgba(35, 121, 155, 0.6);
}
.divices-list >>> .el-tree-node__content:hover {
    background-color: rgba(35, 121, 155, 0.6);
}
.alarm-scroll{
  height: 100%;
}
.alarm-status{
  padding: 30px;
  font-size: 16px;
  border: 2px solid rgb(0, 116, 199);
  border-radius: 5px;
}
.alarm-status_title{
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: bolder;

}
.el-form-item {
  margin-bottom: 0px;
}
.alarm-status_button{
  text-align: center;
  margin-top: 20px;
}
.el-popover {
  border: 2px solid  rgb(0, 116, 199);
}
.alarm-item, .alarm-item_highlight{
  font-size: 16px;
  cursor: pointer;
  line-height: 25px;
}
.alarm-item_highlight {
  background-color: #409EFF;
}
.el-divider {
  margin: 0px;
}
.device-scroll{
  height: 80%;
  overflow: auto;
  margin-top: 10px;
  margin-bottom: 20px;
}
::-webkit-scrollbar-track-piece{
  background-color:  rgba(35, 121, 155, 0.6);
}
::-webkit-scrollbar-corner {
  background-color:  rgba(35, 121, 155, 0.6);
}
::-webkit-scrollbar {
  background-color:  rgba(35, 121, 155, 0.6);
}
::-webkit-scrollbar-track {
  background-color:  rgba(35, 121, 155, 0.6);
}
.no-permission{
  text-align: center;
  font-size: 20px;
}
</style>



